import { useMedplum } from '@medplum/react';
import { useEffect } from 'react';

export function SignOutPage(): null {
  const medplum = useMedplum();

  useEffect(() => {
    window.location.href = '/';
    medplum.signOut().catch(console.error);
  }, [medplum]);

  return null;
}
